import React, { FC, memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Popover from '../../../../../common/popover/popover';
import Routes from '../../../../../constants/routes';
import useIsMobile from '../../../../../hooks/use-is-mobile';
import { ReactComponent as IconProfile } from '../../../../../images/user-icon.svg';
import translation from '../../../../../languages';
import analytics from '../../../../../services/analytics';
import cn from '../../../../../utils/classnames';
import hidePopover from '../../../../../utils/hide-popover';
import session from '../../../../../utils/session';
import MenuContent from './components/menu-content/menu-content';
import TriggerAs from './components/trigger-as/trigger-as';
import { MENU_STATE_TYPES } from './user-menu.constants';
import './user-menu.scss';

const translate = translation('header');

const MobileMenuTitle = translate(
    ({ t, isActiveNavigationAbTest }: TranslationProps & { isActiveNavigationAbTest: boolean }) => (
        <div className='menu-item menu-title' onClick={hidePopover}>
            {' '}
            <IconProfile />
            <div className='text-holder text-center'>
                <div className={cn('ellipsis text', { 'tsc-caption': isActiveNavigationAbTest })}>
                    {t('header.userMenu.main')}
                </div>
            </div>
        </div>
    )
);

const UserMenu: FC = () => {
    const user = useSelector((state: RootState) => state.main.user);
    const isActiveNavigationAbTest = useSelector(
        (state: RootState) => state.main.schoolClassification.isActiveNavigationAbTest
    );
    const [menuState, setMenuState] = useState(MENU_STATE_TYPES.LOGIN);
    const mobile = useIsMobile(767);

    useEffect(() => {
        if (!session.isLoggedIn()) {
            window.storage.removeItem('isSeller');
        }
    }, []);

    useEffect(() => {
        if (user.id && session.isLoggedIn()) {
            setMenuState(MENU_STATE_TYPES.LOGGED_IN);
        }
    }, [user.id]);

    const onShowMenu = () => {
        analytics.push({
            event: 'gtmEvent',
            eventAction: 'UserMenuOpen',
            eventCategory: 'mkt-userInteraction',
            eventNonInteraction: false
        });
    };

    return (
        <div className='user-menu d-flex align-items-center justify-content-center'>
            {mobile && !session.isLoggedIn() ? (
                <div className='header-user-btn' onClick={() => window.locationReload(Routes.LOGIN.path)}>
                    <IconProfile />
                </div>
            ) : (
                <Popover
                    menu={
                        <div className='user-menu-content d-flex flex-wrap'>
                            <MenuContent menuState={menuState} setMenuState={setMenuState} />
                        </div>
                    }
                    className={cn({ 'without-material-upload': isActiveNavigationAbTest })}
                    mobileTitle={<MobileMenuTitle isActiveNavigationAbTest={isActiveNavigationAbTest} />}
                    triggerAs={<TriggerAs user={user} />}
                    onShown={onShowMenu}
                    trigger='click'
                />
            )}
        </div>
    );
};

export default memo(UserMenu);
